export class Triggers {
  uId: string;
  triggerKey: string;
  name: string;
  description: string;
  triggerid: string;
}
